<template>
  <div class="dashboard body">
    <el-container>
      <!-- <ReportsAside /> -->
      <el-main>
        <button
          v-show="1 == 0"
          v-shortkey="['f10']"
          @shortkey="confirmEdit = true"
        ></button>
        <button
          v-show="1 == 0"
          v-shortkey="['f9']"
          @shortkey="saveShortKey"
        ></button>
        <el-row class="bg-White p-3">
          <el-col :lg="6">
            <h3 style="margin: 0">تعديل الفاتوره</h3>
          </el-col>
          <el-col :lg="9"></el-col>
          <el-col :lg="3">
            <b>رقم الفاتوره : </b>
            <b>{{ purchases[0].id }}</b>
          </el-col>
          <el-col :lg="6">
            <b>اسم المورد : </b>
            <b v-if="supplier">{{ supplier.name }}</b>
          </el-col>
        </el-row>
        <el-row class="table mt-2 px-3">
          <div
            class="el-table el-table--fit el-table--border el-table--scrollable-y el-table--enable-row-hover el-table--enable-row-transition"
            style="margin-top: 20px; height: 70vh"
          >
            <div class="el-table__header-wrapper">
              <table
                cellspacing="0"
                cellpadding="0"
                border="0"
                class="el-table__header"
                style="width: 100%"
              >
                <colgroup>
                  <col name="el-table_3_column_11" width="4%" />
                  <col name="el-table_3_column_12" width="30%" />
                  <col name="el-table_3_column_13" width="15%" />
                  <col name="el-table_3_column_14" width="15%" />
                  <col name="el-table_3_column_15" width="10%" />
                  <col name="el-table_3_column_16" width="10%" />
                  <col name="el-table_3_column_17" width="10%" />
                </colgroup>
                <thead class="has-gutter">
                  <tr class="">
                    <th
                      colspan="1"
                      rowspan="1"
                      class="el-table_3_column_11 is-leaf"
                    >
                      <div class="cell">#</div>
                    </th>
                    <th
                      colspan="1"
                      rowspan="1"
                      class="el-table_3_column_12 is-leaf"
                    >
                      <div class="cell">المنتج</div>
                    </th>
                    <th
                      colspan="1"
                      rowspan="1"
                      class="el-table_3_column_13 is-leaf"
                    >
                      <div class="cell">الكمية</div>
                    </th>
                    <th
                      colspan="1"
                      rowspan="1"
                      class="el-table_3_column_13 is-leaf"
                    >
                      <div class="cell">اضافة كمية</div>
                    </th>
                    <th
                      colspan="1"
                      rowspan="1"
                      class="el-table_3_column_14 is-leaf"
                    >
                      <div class="cell">سعر الشراء</div>
                    </th>
                    <th
                      colspan="1"
                      rowspan="1"
                      class="el-table_3_column_15 is-leaf"
                    >
                      <div class="cell center">الإجمالي</div>
                    </th>
                    <th
                      colspan="1"
                      rowspan="1"
                      class="el-table_3_column_16 is-leaf"
                    >
                      <div class="cell center">المتاح</div>
                    </th>
                  </tr>
                </thead>
              </table>
            </div>
            <!-- id="scrollToMe" -->
            <div
              class="el-table__body-wrapper"
              style="height: auto; max-height: 55vh"
              ref="products_table"
            >
              <table
                cellspacing="0"
                cellpadding="0"
                class="el-table__body-wrapper"
                style="height: auto; max-height: 45vh"
                ref="products_table"
              >
                <colgroup>
                  <col name="el-table_3_column_11" width="4%" />
                  <col name="el-table_3_column_12" width="26%" />
                  <col name="el-table_3_column_13" width="10%" />
                  <col name="el-table_3_column_14" width="10%" />
                  <col name="el-table_3_column_15" width="10%" />
                  <col name="el-table_3_column_16" width="10%" />
                  <col name="el-table_3_column_17" width="10%" />
                </colgroup>
                <tbody class="body">
                  <tr
                    class="el-table__row"
                    v-for="(item, index) in purchases[selectedIndex].products"
                    :key="index"
                    :class="
                      item.pivot.qty < item.pivot.old_qty &&
                      item.pivot.old_qty - item.pivot.qty > item.stock
                        ? 'bg-danger'
                        : ''
                    "
                  >
                    <template>
                      <td rowspan="1" colspan="1" class="el-table_3_column_11">
                        <div class="cell num">{{ index + 1 }}</div>
                      </td>
                      <td rowspan="1" colspan="1" class="el-table_3_column_12">
                        <div class="cell">{{ item.name }}</div>
                      </td>
                      <td rowspan="1" colspan="1" class="el-table_3_column_13">
                        <div class="cell">{{ item.pivot.old_qty }}</div>
                      </td>
                      <td rowspan="1" colspan="1" class="el-table_3_column_14">
                        <div class="cell">
                          <!-- <vs-tooltip
                            top
                            shadow
                            not-hover
                            v-model="item.showQtyToolTip"
                          >
                            <template #tooltip>
                              <div class="content-tooltip">
                                لا يمكن ادخال كمية اقل من الشراء
                              </div>
                            </template>
                          </vs-tooltip> -->
                          <el-popover
                            :ref="item.id + '-' + item.pivot.unit_type"
                            placement="left"
                            trigger="manual"
                            content="لا يمكن ادخال كمية اقل عن ما تم بيعه"
                            v-model="item.showQtyToolTip"
                            class="bg-danger"
                            style="
                              background-color: #f56c6c !important;
                              color: #fff !important;
                            "
                          >
                          </el-popover>
                          <input
                            type="number"
                            class="form-control"
                            style="height: 40px !important"
                            min="0"
                            @change="checkValidQty(item)"
                            @focus="$event.target.select()"
                            v-model="item.pivot.new_qty"
                            v-popover="item.id + '-' + item.pivot.unit_type"
                          />
                        </div>
                      </td>
                      <td rowspan="1" colspan="1" class="el-table_3_column_15">
                        <div class="cell">
                          <input
                            type="number"
                            class="form-control"
                            @change="calcTotal"
                            @focus="$event.target.select()"
                            v-model="item.pivot.buy_cost"
                          />
                        </div>
                      </td>
                      <td rowspan="1" colspan="1" class="el-table_3_column_16">
                        <div class="cell text-center">
                          {{
                            numberToFixed(item.pivot.buy_cost * (item.pivot.new_qty))
                          }}
                        </div>
                      </td>
                      <td rowspan="1" colspan="1" class="el-table_3_column_17">
                        <div class="cell text-center">
                          {{ numberToFixed(item.stock) }}
                        </div>
                      </td>
                    </template>
                  </tr>
                </tbody>
              </table>
              <a id="goToBottom" href="#scrollToMe"></a>
              <div id="scrollToMe"></div>
            </div>
            <div class="el-table__footer-wrapper">
              <table
                cellspacing="0"
                cellpadding="0"
                border="0"
                class="el-table__footer"
                style="width: 100%"
              >
                <colgroup>
                  <col name="el-table_3_column_11" width="15%" />
                  <col name="el-table_3_column_12" width="30%" />
                  <col name="el-table_3_column_13" width="15%" />
                  <col name="el-table_3_column_14" width="15%" />
                  <col name="el-table_3_column_15" width="15%" />
                  <col name="el-table_3_column_16" width="15%" />
                  <col name="el-table_3_column_17" width="16%" />
                </colgroup>
                <tbody class="has-gutter footer">
                  <tr>
                    <td
                      colspan="2"
                      rowspan="1"
                      class="el-table_3_column_11 is-leaf"
                    >
                      <div class="cell">
                        <div class="searchInput">
                          <SearchProducts
                            :showStockZero="true"
                            :supplier="supplier"
                            ref="searchProductsComponent"
                            @selectedProduct="selectedProduct"
                            @selectedProductWithBarcode="
                              selectedProductWithBarcode
                            "
                          />
                        </div>
                      </div>
                    </td>
                    <td
                      colspan="2"
                      rowspan="1"
                      class="el-table_3_column_13 is-leaf"
                    >
                      <div class="cell qty">
                        <el-input
                          type="number"
                          ref="qty"
                          @focus="$event.target.select()"
                          @keyup.enter.native="setPriceFocus"
                          v-model="qty"
                          controls-position="right"
                        ></el-input>
                      </div>
                    </td>
                    <td
                      colspan="1"
                      rowspan="1"
                      class="el-table_3_column_14 is-leaf"
                    >
                      <div class="cell buy_cost">
                        <el-input
                          type="number"
                          ref="buy_cost"
                          v-model="buy_cost"
                          @focus="$event.target.select()"
                          @keyup.enter.native="addNewItem"
                          controls-position="right"
                        ></el-input>
                      </div>
                    </td>
                    <td
                      colspan="1"
                      rowspan="1"
                      class="el-table_3_column_15 is-leaf"
                    >
                      <div class="cell text-center" v-if="qty * buy_cost > 0">
                        {{ qty * buy_cost }}
                      </div>
                      <div class="cell text-center" v-else>-</div>
                    </td>
                    <td
                      colspan="1"
                      rowspan="1"
                      class="el-table_3_column_16 is-leaf"
                    >
                      <div class="cell text-center">
                        {{ selectedProductStock }}
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </el-row>
        <el-row
          :gutter="10"
          class="footer"
          v-if="purchases[0].products.length > 0"
        >
          <el-col :xl="8" :lg="8" :md="18" :sm="24"
            ><div class="bg-White alignment px-3 mt-2">
              <el-row :gutter="5">
                <el-col :span="12">
                  <label for="">خصم بالقيمة</label>
                  <input
                    class="form-control"
                    @change="discountChange"
                    @focus="$event.target.select()"
                    v-model="purchases[selectedIndex].discount"
                    placeholder="قيمه الخصم"
                    align="middle"
                  />
                </el-col>
                <el-col
                  :span="12"
                  v-if="purchases[selectedIndex].products.length > 0"
                >
                  <label for="">خصم بالنسبة %</label>
                  <input
                    class="form-control"
                    @change="discountPreChange"
                    @focus="$event.target.select()"
                    v-model="percentageDiscount"
                    placeholder="الخصم بالنسبة المئوية"
                  />
                </el-col>
              </el-row>
            </div>
          </el-col>
          <el-col :xl="4" :lg="4" :md="18" :sm="24"
            ><div class="bg-White alignment p-3 mt-2">
              <p>
                الكميه
                <span class="num">{{ purchases[0].total_qty }}</span>
              </p>
            </div>
          </el-col>
          <el-col :xl="12" :lg="12" :md="6" :sm="24"
            ><div class="bg-White mt-2">
              <p class="px-3" v-if="purchases[0].products.length > 0">
                الفاتوره
                <span>{{ numberToFixed(purchases[0].total_buy_cost) }}</span>
              </p>
              <p class="px-3" v-if="purchases[0].discount > 0">
                بعد الخصم
                <span>{{
                  numberToFixed(
                    purchases[0].total_buy_cost - purchases[0].discount
                  )
                }}</span>
              </p>
              <el-button
                class="save"
                :disabled="disabled"
                :loading="isLoading"
                @click="confirmEdit = true"
                >حفظ الفاتوره</el-button
              >
              <el-popconfirm
                v-if="accessLinks('add_purchase_return_bill')"
                confirm-button-text="موافق"
                cancel-button-text="إلغاء"
                icon="el-icon-info"
                icon-color="red"
                title="هل  تريد  اضافة مرتجع للفاتورة ؟  "
                @confirm="goTo(`/purchases/return/${purchases[0].id}`)"
              >
                <el-button slot="reference" class="exit mr-3"
                  >انشاء مرتجع
                </el-button>
              </el-popconfirm>
              <el-popconfirm
                confirm-button-text="موافق"
                cancel-button-text="إلغاء"
                icon="el-icon-info"
                icon-color="red"
                title="هل تريد الرجوع للتقرير؟"
                @confirm="goTo('/purchases/report')"
              >
                <el-button slot="reference" class="exit mr-3">الغاء</el-button>
              </el-popconfirm>
            </div>
          </el-col>
        </el-row>
      </el-main>
    </el-container>
    <div v-if="confirmEdit == true" class="dialog">
      <div class="bodySec">
        <p @click="confirmEdit = false">
          <span><i class="far fa-times-circle"></i></span> اغلاق
        </p>
      </div>
      <div class="content">
        <div class="headerSection">
          <p>الفاتوره قبل التعديل</p>
          <p class="mr-auto">
            {{ totalInvoice - purchases[0].discount }}
          </p>
        </div>
        <div class="headerSection mt-2">
          <p>الفاتورة بعد التعديل</p>
          <p class="mr-auto">
            {{
              numberToFixed(
                (purchases[0].total_buy_cost - purchases[0].discount)
              )
            }}
          </p>
        </div>
        <div class="headerSection mt-2">
          <p>فرق الفاتوره</p>
          <p class="mr-auto">
            {{
              numberToFixed(
                (purchases[0].total_buy_cost - purchases[0].discount) -
                  (totalInvoice  -  purchases[0].discount)
              )
            }}
          </p>
        </div>
        <div class="mt-2">
          <el-radio-group
            v-model="setPaied"
            style="justify-content: start !important"
          >
            <el-radio-button label="without">حفظ بدون توريد</el-radio-button>
            <el-radio-button @click="alert" label="returnAmount"
              >توريد</el-radio-button
            >
          </el-radio-group>
        </div>
        <div v-if="setPaied == 'returnAmount'">
          <el-row>
            <el-col> <p class="label">المبلغ المدفوع</p></el-col>
            <el-col>
              <input
                class="form-control"
                @focus="$event.target.select()"
                id="returnAmount"
                v-model="purchases[0].paied"
              />
            </el-col>
          </el-row>
        </div>
        <el-button
          class="mt-3 btn-green1 btn-save"
          @click="editSale"
          type="success"
          >حفظ</el-button
        >
        <el-button type="danger" @click="confirmEdit = false" class="exit mr-2"
          >الغاء</el-button
        >
      </div>
      <br />
    </div>
  </div>
</template>

<script>
// import ReportsAside from "@/components/ReportsAside.vue";
import SearchProducts from "@/components/Products/SearchWithLastBuyPrice";
import axiosApi from "@/plugins/axios.js";

export default {
  components: {  SearchProducts },
  name: "EditPurchase",
  data: () => ({
    true: true,
    useParcode: false,
    autoPush: false,
    allowDeletePayment: false,
    disabled: false,
    isLoading: false,
    false: false,
    supplier: null,
    product: null,
    productUnits: [],
    selectedUnit: null,
    buy_cost: "",
    min_price: "",
    qty: 1,
    active: "edit_purchases",
    confirmSave: false,
    confirmEdit: false,
    totalInvoice: 0,
    timeout: null,
    selectedProductlastSaleCost: "-",
    selectedProductStock: "-",
    value: "",
    num: 1,
    ind: 0,
    selectedPorductIndex: 0,
    setPaied: "without",
    activeDelete: false,
    selectedIndex: 0,
    showPrice: false,
    percentageDiscount: 0,
    purchases: [
      {
        id: "",
        inventory_id: 1,
        paied: 0,
        returned_amount: 0,
        VAT: 0,
        supplier: null,
        total_cost: 0,
        total_buy_cost: 0,
        total_sale_cost: 0,
        total_qty: 0,
        discount: 0,
        total_discount: 0,
        percentage: 0,
        percentage_discount: 0,
        products: [],
      },
    ],
  }),
  watch: {
    setPaied: function (v) {
      this.purchases[0].paied = 0;
      this.purchases[0].returnAmount = 0;
      if (v === "with") {
        setTimeout(() => {
          document.getElementById("paied").focus();
        }, 100);
      } else if (v === "returnAmount") {
        setTimeout(() => {
          document.getElementById("returnAmount").focus();
        }, 100);
      }
    },
  },
  created() {
    if (localStorage.getItem("edited_purchases")) {
      let sale_data = localStorage.getItem("edited_purchases");
      this.purchases = JSON.parse(sale_data);
      this.supplier = this.purchases[0].supplier;
      this.calcTotal();
    } else {
      if (this.$route.params.id > 0) {
        this.getInvoice();
      }
    }
  },
  mounted() {
    this.scrollToEnd();
  },
  methods: {
    alert() {
      alert("price clicked");
    },
    discountPreChange() {
      this.purchases[0].discount = Number(
        (Number(this.percentageDiscount) * this.purchases[0].total_buy_cost) /
          100
      ).toFixed(2);
      this.setLocalStorage();
    },
    discountChange() {
      this.percentageDiscount = (
        Number(
          Number(this.purchases[0].discount) / this.purchases[0].total_buy_cost
        ) * 100
      ).toFixed(2);
      this.setLocalStorage();
    },
    getInvoice() {
      if (this.$route.params.id > 0) {
        axiosApi
          .get(`purchases/${this.$route.params.id}`)
          .then((response) => {
            if (response.data.length > 0) {
              this.purchases = response.data;
              this.supplier = response.data[0].supplier;
              this.purchases[0].total_buy_cost = this.purchases[0].total_cost - this.purchases[0].returned_amount;
              this.purchases[0].discount = response.data[0].discount;
              this.discountChange();
              let qty = 0;
              let total_sale_cost = 0;
              this.purchases[0].products.map(function (value) {
                value["pivot"]["new_qty"] =
                  value["pivot"]["qty"] - value["pivot"]["returned_qty"];
                qty += value["pivot"]["qty"] - value["pivot"]["returned_qty"];
                total_sale_cost +=
                  (value["pivot"]["qty"] - value["pivot"]["returned_qty"]) * value["pivot"]["buy_cost"];
                value["pivot"]["old_qty"] =
                  value["pivot"]["qty"] - value["pivot"]["returned_qty"];
                value["showQtyToolTip"] = false;
              });
              this.purchases[0].total_qty = qty;
              this.purchases[0].total_sale_cost = total_sale_cost;
              this.totalInvoice = this.purchases[0].total_buy_cost;
            }
            this.checkStock();
          })
          .catch((e) => {
            console.log(e);
          });
      } else {
        console.log("من فضلك حدد رقم الفاتورة أولا للبحث");
      }
    },
    showPaymentModal() {
      this.confirmSave = true;
    },
    setPriceFocus() {
      document.querySelector(".buy_cost input").focus();
    },
    selectedsupplier(e) {
      this.supplier = e.supplier;
      this.purchases[this.selectedIndex].supplier = e.supplier;
      this.setLocalStorage();
      document.querySelector(".productQuery input").focus();
    },
    selectedProduct(e) {
      this.product = e.product;
      if (this.product != null) {
        this.$refs.searchProductsComponent.setValue(this.product);
        this.selectedUnit = this.product.prices[0];
        this.buy_cost =
          this.product.inventories.length > 0 &&
          this.product.inventories[0].pivot.buy_cost;
        this.sale_price =
          this.product.prices.length > 0 && this.product.prices[0].sale_price;
        if (this.product.lastPurchase != null) {
          this.selectedProductlastBuyCost = this.product.lastPurchase.buy_cost;
        } else {
          this.selectedProductlastBuyCost = "-";
        }
        this.selectedProductStock =
          (this.product.inventories[0].pivot.qty -
            this.product.inventories[0].pivot.hold_qty) /
          this.product.units_per_package;
        setTimeout(() => {
          document.querySelector(".qty input").focus();
        }, 200);
      } else {
        this.clearProduct();
      }
    },
    selectedProductWithBarcode(e) {
      this.product = e.product;
      if (this.product != null) {
        this.$refs.searchProductsComponent.setValue(this.product);
        this.selectedUnit = this.product.prices[0];
        this.buy_cost =
          this.product.inventories.length > 0 &&
          this.product.inventories[0].pivot.buy_cost;
        this.sale_price =
          this.product.prices.length > 0 && this.product.prices[0].sale_price;
        if (this.product.lastPurchase != null) {
          this.selectedProductlastBuyCost = this.product.lastPurchase.buy_cost;
        } else {
          this.selectedProductlastBuyCost = "-";
        }
        this.selectedProductStock =
          (this.product.inventories[0].pivot.qty -
            this.product.inventories[0].pivot.hold_qty) /
          this.product.units_per_package;
        if (this.autoPush) {
          this.qty = "1";
          this.addNewItem();
        } else {
          setTimeout(() => {
            document.querySelector(".qty input").focus();
          }, 200);
        }
      } else {
        this.clearProduct();
      }
    },
    checkStock() {
      const loading = this.$loading({
        lock: true,
        text: "جاري تحميل البيانات",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      axiosApi
        .post(`edit-receipt/check-stock`, {
          products: this.purchases[this.selectedIndex].products,
        })
        .then((res) => {
          loading.close();
          console.log("edit-receipt/check-stock", res.data);
          this.purchases[this.selectedIndex].products = res.data;
          this.checkQty();
        })
        .catch(() => {
          loading.close();
        });
    },
    addNewItem() {
      if (this.qty > 0) {
        if (this.product.inventories.length == 0) {
          this.$snotify.error(` ${this.product.name} عفوا لا يوجد مخزون من `);
        } else {
          const vm = this;
          let unit_type = this.selectedUnit.type;
          var product = this.purchases[0].products.filter(function (elem) {
            if (elem.id == vm.product.id) return elem;
          });
          if (product.length > 0) {
            this.purchases[0].products.splice(
              this.purchases[0].products.findIndex(
                (e) => e.id == vm.product.id && e.pivot.unit_type == unit_type
              ),
              1
            );
            this.purchases[0].products.push({
              id: product[0].id,
              name: product[0].name,
              pivot: {
                buy_cost: product[0]["pivot"].buy_cost,
                discount: 0,
                product_id: product[0]["pivot"].id,
                qty: Number(product[0]["pivot"].qty) + Number(this.qty),
                old_qty: product[0]["pivot"].old_qty,
                returned_qty: product[0]["pivot"].returned_qty,
                new_qty: (Number(product[0]["pivot"].qty) - Number(product[0]["pivot"].returned_qty)) + Number(this.qty),
                unit: product[0]["pivot"].unit,
                unit_type: product[0]["pivot"].unit_type,
                units_per_package: product[0]["pivot"].units_per_package,
              },
              stock: product[0].stock,
              min_price: product[0].min_price,
              units_per_package: product[0]["pivot"].units_per_package,
              lastSaleCost: product[0].lastSaleCost,
              qty: Number(product[0].qty) + Number(this.qty),
            });
            this.calcTotal();
            this.clearProduct();
            this.setLocalStorage();
          } else {
            let lastSaleCost = "";
            if (this.selectedUnit.type == 1) {
              if (this.product.mainUnitLastInvoice != null) {
                lastSaleCost = this.product.mainUnitLastInvoice.buy_cost;
              }
            } else if (this.selectedUnit.type == 2) {
              if (this.product.secondUnitLastInvoice != null) {
                lastSaleCost = this.product.secondUnitLastInvoice.buy_cost;
              }
            } else {
              lastSaleCost = "";
            }
            let qty = 0;
            let stock = 0;
            if (this.product.inventories.length > 0) {
              qty =
                this.product.inventories[0].pivot.qty -
                this.product.inventories[0].pivot.hold_qty;
              if (this.selectedUnit.type == 1) {
                stock = Number(qty / this.product.units_per_package);
              } else {
                stock = qty;
              }
            }
            this.purchases[0].products.push({
              id: this.product.id,
              name: this.product.name,
              pivot: {
                discount: 0,
                product_id: this.product.id,
                qty: Number(this.qty),
                old_qty: 0,
                new_qty: Number(this.qty),
                returned_qty: 0,
                buy_cost: this.buy_cost,
                unit: this.selectedUnit.unit,
                unit_type: this.selectedUnit.type,
                units_per_package: this.product.units_per_package,
              },
              units_per_package: this.product.units_per_package,
              stock: stock,
              min_price: this.min_price,
              lastSaleCost: lastSaleCost,
              qty: Number(this.qty),
            });
            this.setLocalStorage();
            this.calcTotal();
            this.clearProduct();
          }
          // end hold
        }
      }
      this.scrollToEnd();
    },
    editSale() {
      if (!this.isLoading) {
        if (this.purchases[0].products.length > 0) {
          this.isLoading = true;
          this.purchases[0].total_discount = this.purchases[0].discount;
          this.purchases[0].products.map(function (value) {
            value["pivot"]["qty"] = Number(value["pivot"]["new_qty"]);
          });
          const loading = this.$loading({
            lock: true,
            text: "جاري تحميل البيانات",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
          axiosApi
            .put(`purchases/${this.purchases[0].id}`, this.purchases[0])
            .then((response) => {
              this.invoice_details = response.data.invoice_details;
              localStorage.setItem(
                "purchase_edited_invoice",
                JSON.stringify(response.data.invoice_details)
              );
              this.$notify({
                title: "تمت العملية بنجاح",
                message: "تم حفظ بيانات الفاتورة بنجاح",
                type: "success",
                duration: 1500,
              });
              setTimeout(() => {
                this.$router.push("/purchases/report");
              }, 100);
            })
            .catch((err) => {
              if (err.response.status == 403) {
                this.$notify.error({
                  title: "حدث خطأ",
                  message: "عفوا تأكد من كمية المنتج",
                  duration: 1500,
                });
                for (let i = 0; i < this.purchases[0].products.length; i++) {
                  this.purchases[0].products[i].pivot.old_qty =
                    err.response.data[0].products[i].pivot.qty -
                    err.response.data[0].products[i].pivot.returned_qty;
                }
                this.confirmEdit = false;
              }
            })
            .finally(() => {
              loading.close();
              this.isLoading = false;
            });
        }
      }
    },
    calcTotal() {
      // this.checkStock();
      let buy_cost = 0;
      let sale_total = 0;
      this.allowSale = true;
      var qty = 0;
      for (var i = 0; i < this.purchases[0].products.length; i++) {
        if (
          this.purchases[0].products[i].pivot.buy_cost >
          this.purchases[0].products[i].pivot.buy_cost
        ) {
          this.allowSale = false;
        }
        if (this.purchases[0].products[i].pivot.qty == "") {
          this.purchases[0].products[i].pivot.qty = 1;
        }
        let buy = Number(
          (this.purchases[0].products[i].pivot.new_qty ) *
            this.purchases[0].products[i].pivot.buy_cost
        );
        buy_cost = buy_cost + buy;
        let sale = Number(
          this.purchases[0].products[i].pivot.new_qty *
            this.purchases[0].products[i].pivot.buy_cost
        );
        sale_total = sale_total + sale;
        qty = qty + (Number(this.purchases[0].products[i].pivot.qty) - Number(this.purchases[0].products[i].pivot.returned_qty));

        this.checkQty();
        this.purchases[0].total_buy_cost = Number(buy_cost);
        this.purchases[0].total_sale_cost = Number(sale_total);
        this.purchases[0].total_qty = Number(qty);
      }
      this.discountChange();
      this.setLocalStorage();
    },
    checkQty() {
      for (var i = 0; i < this.purchases[0].products.length; i++) {
        this.purchases[0].products[i].pivot.qty = Number(
          this.purchases[0].products[i].pivot.qty
        );
        let qty = 0;
        if (
          Number(this.purchases[0].products[i].pivot.qty) <
          Number(this.purchases[0].products[i].pivot.old_qty)
        ) {
          qty =
            Number(this.purchases[0].products[i].pivot.old_qty) -
            Number(this.purchases[0].products[i].pivot.qty);
        }
        if (qty > Number(this.purchases[0].products[i].stock)) {
          console.log(qty, Number(this.purchases[0].products[i].pivot.old_qty));
          this.disabled = true;
          return 1;
        } else {
          this.disabled = false;
        }
        if (this.purchases[0].products[i].pivot.qty == "") {
          this.purchases[0].products[i].pivot.qty = 1;
        }
      }
    },
    setLocalStorage() {
      localStorage.setItem("edit_purchases", JSON.stringify(this.purchases));
    },
    clearProduct() {
      this.qty = "";
      this.selectedProductStock = "-";
      this.selectedProductlastSaleCost = "-";
      this.buy_cost = "";
      this.product = null;
      this.selectedUnit = null;
      this.productUnits = [];
      if (this.$refs.searchProductsComponent) {
        this.$refs.searchProductsComponent.setValue(null);
        setTimeout(() => {
          document.querySelector(".productQuery input").focus();
        }, 100);
      }
    },
    numberToFixed(number) {
      return Math.floor(number * 100) / 100;
    },
    scrollToEnd() {
      setTimeout(() => {
        let elementToScrollDown = this.$refs.products_table;
        elementToScrollDown.scrollTop = elementToScrollDown.scrollHeight;
      }, 300);
      console.log("scrollToEnd");
    },
    goTo(routerName) {
      this.$router.push({ path: routerName });
    },
    useBarcode() {
      if (this.useParcode) {
        document.querySelector(".parcodeSearch input[type='text']").focus();
      } else {
        document.querySelector(".productQuery input").focus();
      }
    },
    saveShortKey() {
      if (this.confirmEdit) {
        this.editSale();
      }
    },
    checkValidQty(item) {
      if (item.pivot.new_qty < item.pivot.old_qty) {
        item.showQtyToolTip = true;
      } else if (item.pivot.new_qty >= item.pivot.old_qty) {
        item.showQtyToolTip = false;
        this.calcTotal();
      }
    },
    accessLinks(link) {
      let permissionNames = JSON.parse(localStorage.getItem("permissionNames"));
      return permissionNames.includes(link);
    },
  },
};
</script>

<style scoped>
#scrollToMe {
  overflow-y: scroll;
}
.text-center {
  text-align: center !important;
}
</style>
